import { useUiStore } from '@/stores/uiStore';
import type { ConnectionStatus } from '@/stores/uiStore';

const STATUS_LABEL: Record<ConnectionStatus, string> = {
  connecting: 'Connecting…',
  open: 'Live',
  closed: 'Disconnected',
  stale: 'Stale data',
};

const STATUS_DOT: Record<ConnectionStatus, string> = {
  connecting: 'bg-warning',
  open: 'bg-success',
  closed: 'bg-danger',
  stale: 'bg-warning',
};

export function Topbar() {
  const toggleSidebar = useUiStore((s) => s.toggleSidebar);
  const connectionStatus = useUiStore((s) => s.connectionStatus);

  return (
    <header className="sticky top-0 z-30 flex items-center justify-between gap-md border-b border-border bg-surface/95 backdrop-blur px-md lg:px-lg h-16">
      <div className="flex items-center gap-3">
        <button
          type="button"
          aria-label="Open navigation"
          onClick={toggleSidebar}
          className="lg:hidden w-9 h-9 inline-flex items-center justify-center rounded-md text-text hover:bg-surface-secondary"
        >
          ☰
        </button>
        <div className="lg:hidden">
          <p className="text-base font-bold text-primary leading-tight">SHIVORAA PEER</p>
        </div>
      </div>

      <div
        className="flex items-center gap-2 rounded-pill border border-border bg-surface-secondary px-3 py-1.5 text-xs font-medium text-text-secondary"
        role="status"
        aria-label={`WebSocket connection status: ${STATUS_LABEL[connectionStatus]}`}
      >
        <span className={`h-2 w-2 rounded-pill ${STATUS_DOT[connectionStatus]}`} aria-hidden="true" />
        {STATUS_LABEL[connectionStatus]}
      </div>
    </header>
  );
}
